var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$temAcessoView('CONT-REQ-05'))?_c('b-button',{attrs:{"variant":"danger","disabled":_vm.comprometimentosSelecionados.length == 0},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarExcluirSelecionados()}}},[_c('span',[_c('i',{staticClass:"fa fa-trash mr-2"}),_vm._v(" Excluir rateios selecionados")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }